import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#d32f2f',
      dark: '#b71c1c',
      light: '#f44336',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#424242',
      dark: '#1e1e1e',
      light: '#757575',
      contrastText: '#ffffff',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
    text: {
      primary: '#ffffff',
      secondary: '#B0BEC5',
      disabled: '#757575',
    },
  },
  typography: {
    fontFamily: "'Outfit', sans-serif", // ✅ Change font to Outfit
    body1: {
      color: '#B0BEC5',
    },
    button: {
      textTransform: 'none',
      fontWeight: 'bold',
    },
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: "'Outfit', sans-serif", // ✅ Apply to all TableCell components
          fontSize: '14px',
          color: '#ffffff',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
        },
        containedPrimary: {
          backgroundColor: '#d32f2f',
          '&:hover': {
            backgroundColor: '#b71c1c',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: '#252525',
          color: '#fff',
          '& .MuiInputBase-input': {
            color: '#B0BEC5',
          },
          '& .MuiInputLabel-root': {
            color: '#B0BEC5',
          },
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          color: '#fff',
          backgroundColor: '#252525',
          '&.Mui-selected': {
            backgroundColor: '#b71c1c',
            color: '#fff',
          },
        },
      },
    },
  },
});
